import React from "react";
import "./tooltip.css";
import { Tooltip } from "@mui/material";
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';


export const InfoIconCustomTooltip = (quotesHistoricPrices) => {
   var displayedText = []; 
   var Text = [];
   if(quotesHistoricPrices.length > 0){
     displayedText = quotesHistoricPrices.split(", ");
     var historicPriceHeader = "Top 3 Historic prices"
     Text.push(<span  style={{ fontWeight : "bold" }}>{historicPriceHeader}</span>);
     for (const text of displayedText) {
       Text.push(<li>{text}</li>);
     }
     return(
        <div class="info-icon">
            <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20">
            <path d="M466-306h28v-214h-28v214Zm14-264q8.5 0 14.25-5.75T500-590q0-8.5-5.75-14.25T480-610q-8.5 0-14.25 5.75T460-590q0 8.5 5.75 14.25T480-570Zm.174 438Q408-132 344.442-159.391q-63.559-27.392-110.575-74.348-47.015-46.957-74.441-110.435Q132-407.652 132-479.826q0-72.174 27.391-135.732 27.392-63.559 74.348-110.574 46.957-47.016 110.435-74.442Q407.652-828 479.826-828q72.174 0 135.732 27.391 63.559 27.392 110.574 74.348 47.016 46.957 74.442 110.435Q828-552.348 828-480.174q0 72.174-27.391 135.732-27.392 63.559-74.348 110.575-46.957 47.015-110.435 74.441Q552.348-132 480.174-132ZM480-160q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/>
            </svg>
            <span class="tooltip-text">
                <p>{Text}</p>
            </span>
        </div>
   ); 
};
};

export const CustomToolTipQuoteResultDeleteIcon = ({checkDisable, title}) => {
  return (
    <span className="text-xs w-max flex text-danger">
      <Tooltip title={title}>
        <DeleteOutlineRoundedIcon className="flex flex-col items-center" color={checkDisable} />
      </Tooltip>
    </span>
  );
};

